export type LeaveType = 'annual_leave' | 'unpaid_leave' | 'late_arrival' | 'early_departure' | 'women_policy' | 'marriage_leave' | 'bereavement_leave' | 'business_trip';

export type LeaveStatus = 'pending' | 'approved' | 'rejected';

export interface LeaveRecord {
  id: string;
  userId: string;
  type: LeaveType;
  startDate: string;
  endDate: string;
  startTime: string | null;
  endTime: string | null;
  reason: string;
  status: LeaveStatus;
  createdAt: string;
  approvedBy: string | null;
  rejectedReason: string | null;
  handoverTo: string | null;
  handoverNote: string | null;
  approver: string | null;
}

export const leaveTypeLabels: Record<LeaveType, string> = {
  annual_leave: 'Nghỉ phép năm',
  unpaid_leave: 'Nghỉ không lương',
  late_arrival: 'Đi trễ',
  early_departure: 'Về sớm',
  women_policy: 'Chế độ phụ nữ',
  marriage_leave: 'Kết hôn',
  bereavement_leave: 'Tang chế',
  business_trip: 'Công tác',
};

export const leaveTypeIcons: Record<LeaveType, string> = {
  annual_leave: 'ri-sun-line',
  unpaid_leave: 'ri-money-dollar-circle-line',
  late_arrival: 'ri-run-line',
  early_departure: 'ri-walk-line',
  women_policy: 'ri-women-line',
  marriage_leave: 'ri-heart-line',
  bereavement_leave: 'ri-empathize-line',
  business_trip: 'ri-suitcase-line',
};

export const leaveTypeColors: Record<LeaveType, string> = {
  annual_leave: 'bg-accent-100 text-accent-700',
  unpaid_leave: 'bg-secondary-100 text-secondary-700',
  late_arrival: 'bg-primary-100 text-primary-700',
  early_departure: 'bg-primary-100 text-primary-700',
  women_policy: 'bg-accent-100 text-accent-700',
  marriage_leave: 'bg-accent-100 text-accent-700',
  bereavement_leave: 'bg-foreground-100 text-foreground-700',
  business_trip: 'bg-secondary-100 text-secondary-700',
};

export const leaveStatusLabels: Record<LeaveStatus, string> = {
  pending: 'Chờ duyệt',
  approved: 'Đã duyệt',
  rejected: 'Từ chối',
};

export const leaveStatusColors: Record<LeaveStatus, string> = {
  pending: 'bg-secondary-100 text-secondary-700',
  approved: 'bg-accent-100 text-accent-700',
  rejected: 'bg-primary-100 text-primary-700',
};

export const mockLeaves: LeaveRecord[] = [
  {
    id: 'LEAVE-001',
    userId: 'NV001',
    type: 'annual_leave',
    startDate: '2026-07-10',
    endDate: '2026-07-11',
    startTime: null,
    endTime: null,
    reason: 'Về quê thăm gia đình, có việc cá nhân cần giải quyết trong 2 ngày.',
    status: 'approved',
    createdAt: '2026-06-25T08:30:00',
    approvedBy: 'Trần Thị Bình',
    rejectedReason: null,
    handoverTo: 'NV003',
    handoverNote: 'Bàn giao danh sách khách hàng đang跟进 và báo giá tuần này cho Cường xử lý.',
    approver: 'NV002',
  },
  {
    id: 'LEAVE-002',
    userId: 'NV001',
    type: 'unpaid_leave',
    startDate: '2026-07-20',
    endDate: '2026-07-22',
    startTime: null,
    endTime: null,
    reason: 'Có việc gia đình đột xuất, cần nghỉ 3 ngày để giải quyết. Đã hết phép năm.',
    status: 'pending',
    createdAt: '2026-06-28T09:15:00',
    approvedBy: null,
    rejectedReason: null,
    handoverTo: null,
    handoverNote: null,
    approver: 'NV002',
  },
  {
    id: 'LEAVE-003',
    userId: 'NV001',
    type: 'late_arrival',
    startDate: '2026-06-15',
    endDate: '2026-06-15',
    startTime: '09:30',
    endTime: null,
    reason: 'Sáng có hẹn khám sức khỏe định kỳ, sẽ vào làm trễ khoảng 1 tiếng.',
    status: 'approved',
    createdAt: '2026-06-14T18:00:00',
    approvedBy: 'Trần Thị Bình',
    rejectedReason: null,
    handoverTo: null,
    handoverNote: null,
    approver: 'NV002',
  },
  {
    id: 'LEAVE-004',
    userId: 'NV001',
    type: 'business_trip',
    startDate: '2026-07-05',
    endDate: '2026-07-06',
    startTime: null,
    endTime: null,
    reason: 'Đi công tác tại chi nhánh Đà Nẵng, họp đối tác và kiểm tra thị trường khu vực miền Trung.',
    status: 'pending',
    createdAt: '2026-06-27T14:00:00',
    approvedBy: null,
    rejectedReason: null,
    handoverTo: null,
    handoverNote: null,
    approver: 'NV002',
  },
  {
    id: 'LEAVE-005',
    userId: 'NV001',
    type: 'annual_leave',
    startDate: '2026-06-10',
    endDate: '2026-06-10',
    startTime: null,
    endTime: null,
    reason: 'Xin nghỉ 1 ngày để đi dự đám cưới bạn thân ở tỉnh xa.',
    status: 'rejected',
    createdAt: '2026-06-05T10:00:00',
    approvedBy: 'Trần Thị Bình',
    rejectedReason: 'Phòng đang cao điểm cuối tháng, cần tập trung nhân sự. Vui lòng sắp xếp vào tuần sau.',
    handoverTo: null,
    handoverNote: null,
    approver: 'NV002',
  },
  {
    id: 'LEAVE-006',
    userId: 'NV001',
    type: 'early_departure',
    startDate: '2026-06-20',
    endDate: '2026-06-20',
    startTime: null,
    endTime: '15:30',
    reason: 'Chiều có việc cá nhân cần về sớm, đã sắp xếp xong công việc trong ngày.',
    status: 'approved',
    createdAt: '2026-06-19T16:30:00',
    approvedBy: 'Trần Thị Bình',
    rejectedReason: null,
    handoverTo: null,
    handoverNote: null,
    approver: 'NV002',
  },
  {
    id: 'LEAVE-007',
    userId: 'NV001',
    type: 'women_policy',
    startDate: '2026-07-01',
    endDate: '2026-07-01',
    startTime: null,
    endTime: null,
    reason: 'Xin nghỉ theo chế độ phụ nữ 1 ngày.',
    status: 'approved',
    createdAt: '2026-06-29T07:45:00',
    approvedBy: 'Trần Thị Bình',
    rejectedReason: null,
    handoverTo: null,
    handoverNote: null,
    approver: 'NV002',
  },
  {
    id: 'LEAVE-008',
    userId: 'NV001',
    type: 'marriage_leave',
    startDate: '2026-08-15',
    endDate: '2026-08-17',
    startTime: null,
    endTime: null,
    reason: 'Xin nghỉ kết hôn 3 ngày theo chế độ. Đã đăng ký kết hôn vào ngày 15/08.',
    status: 'pending',
    createdAt: '2026-06-28T11:00:00',
    approvedBy: null,
    rejectedReason: null,
    handoverTo: 'NV006',
    handoverNote: 'Bàn giao công việc quản lý kho và đơn hàng đang xử lý cho Phương (Phó kho).',
    approver: 'NV002',
  },
  {
    id: 'LEAVE-009',
    userId: 'NV001',
    type: 'bereavement_leave',
    startDate: '2026-06-01',
    endDate: '2026-06-03',
    startTime: null,
    endTime: null,
    reason: 'Ông nội mất, xin nghỉ tang chế 3 ngày để về quê lo hậu sự.',
    status: 'approved',
    createdAt: '2026-06-01T06:00:00',
    approvedBy: 'Trần Thị Bình',
    rejectedReason: null,
    handoverTo: 'NV003',
    handoverNote: 'Nhờ Cường hỗ trợ theo dõi đơn hàng và liên hệ khách trong lúc mình vắng mặt.',
    approver: 'NV002',
  },
  {
    id: 'LEAVE-010',
    userId: 'NV003',
    type: 'annual_leave',
    startDate: '2026-07-15',
    endDate: '2026-07-16',
    startTime: null,
    endTime: null,
    reason: 'Xin nghỉ 2 ngày để về quê thăm gia đình, đã lâu chưa về thăm bố mẹ.',
    status: 'approved',
    createdAt: '2026-06-28T10:30:00',
    approvedBy: 'Mai Thanh Tùng',
    rejectedReason: null,
    handoverTo: 'NV007',
    handoverNote: 'Bàn giao danh sách hàng nhập tuần này và lịch kiểm kê cho Hải theo dõi.',
    approver: 'NV009',
  },
  {
    id: 'LEAVE-011',
    userId: 'NV003',
    type: 'early_departure',
    startDate: '2026-07-02',
    endDate: '2026-07-02',
    startTime: null,
    endTime: '15:00',
    reason: 'Có việc gia đình đột xuất, cần về sớm hơn 1.5 tiếng. Công việc trong ca đã hoàn tất.',
    status: 'pending',
    createdAt: '2026-07-01T08:00:00',
    approvedBy: null,
    rejectedReason: null,
    handoverTo: null,
    handoverNote: null,
    approver: 'NV009',
  },
  {
    id: 'LEAVE-012',
    userId: 'NV003',
    type: 'unpaid_leave',
    startDate: '2026-06-22',
    endDate: '2026-06-22',
    startTime: null,
    endTime: null,
    reason: 'Xin nghỉ không lương 1 ngày để giải quyết thủ tục hành chính cá nhân.',
    status: 'rejected',
    createdAt: '2026-06-20T14:00:00',
    approvedBy: 'Mai Thanh Tùng',
    rejectedReason: 'Tuần này kho đang cao điểm nhập hàng, cần đủ nhân sự. Vui lòng sắp xếp vào tuần sau.',
    handoverTo: null,
    handoverNote: null,
    approver: 'NV009',
  },
];